import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import ExpenseListScreen from '../screens/expense/ExpenseListScreen';
import ExpenseFormScreen from '../screens/expense/ExpenseFormScreen';
import ExpenseSearchFiltersScreen from '../screens/expense/ExpenseSearchFiltersScreen';
import ExpenseCategoryListScreen from '../screens/settings/ExpenseCategoryListScreen';

const Stack = createNativeStackNavigator();

const ExpenseNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="ExpenseList" component={ExpenseListScreen} />
      <Stack.Screen name="ExpenseForm" component={ExpenseFormScreen} />
      <Stack.Screen name="ExpenseSearchFilters" component={ExpenseSearchFiltersScreen} />
      <Stack.Screen name="ExpenseCategoryList" component={ExpenseCategoryListScreen} />
    </Stack.Navigator>
  );
};

export default ExpenseNavigator;
